(function () {
  var root = document.getElementById('veyra-discount-quiz');
  if (!root) return;

  var preview = window.location.search.indexOf('veyra_offer_preview=true') > -1;
  var storageKey = 'veyra_45_offer_dismissed_at';
  var week = 7 * 24 * 60 * 60 * 1000;
  var delay = Number(root.dataset.delayMs || 5000);

  function recentlyDismissed() {
    if (preview) return false;
    try { return Date.now() - Number(localStorage.getItem(storageKey) || 0) < week; } catch (error) { return false; }
  }

  function close(remember) {
    root.hidden = true;
    document.body.classList.remove('veyra-offer-open');
    if (remember) { try { localStorage.setItem(storageKey, String(Date.now())); } catch (error) {} }
  }

  function open() {
    if (window.location.pathname.indexOf('/cart') === 0 || recentlyDismissed()) return;
    root.hidden = false;
    document.body.classList.add('veyra-offer-open');
    root.querySelector('.veyra-offer__close')?.focus();
  }

  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-veyra-offer-close]')) close(true);
    if (event.target.closest('[data-veyra-offer-claim]')) close(true);
  });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !root.hidden) close(true); });
  window.setTimeout(open, preview ? 250 : delay);
})();
